<template>
  <div class="register-wrap wrap">
    <h1 class="son-title">
      {{ $t('login.8') }}
    </h1>
    <!-- 注册 表单校验 -->
    <el-form :model="ruleForm" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
      <!-- 手机号 -->
      <el-form-item prop="mobile" class="mobile">
        <el-input :placeholder="$t('login.3')" v-model="ruleForm.mobile" class="input-with-select login-input">
          <el-select v-model="ruleForm.calling_code" slot="prepend" :placeholder="$t('221')" class="login-select">
            <el-option label="+66" value="66"></el-option>
            <el-option label="+62" value="62"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <!-- 请输入图片验证码 -->
      <el-form-item prop="captcha" class="account">
        <el-input
          :placeholder="$t('login.9')"
          v-model="ruleForm.captcha"
          class="input-with-select gl-inner login-input"
        ></el-input>
        <div class="img-wrap" @click="handleImgCode">
          <img :src="codeImg.data" :alt="$t('248')" />
        </div>
      </el-form-item>
      <!-- 请输入短信验证码 -->
      <el-form-item prop="verify_code" class="verify_code">
        <el-input
          :placeholder="$t('login.5')"
          v-model="ruleForm.verify_code"
          class="input-with-select login-inner-code"
        />
        <el-button
          :disabled="!ruleForm.mobile || surplusTime > 0"
          :class="{
            disabled: !ruleForm.mobile,
            time: surplusTime > 0
          }"
          type="primary"
          @click="handleShortCode"
          >{{ codeText }}</el-button
        >
      </el-form-item>
      <!-- 用户使用协议 -->
      <div class="agree-wrap">
        <el-checkbox v-model="checked">{{ $t('807') }}</el-checkbox>
        <a :href="agreeUrl" target="_blank" @click="onAgree">
          <span class="agree">{{ $t('808') }}</span>
        </a>
        <!-- 使用条款 -->
        <span> {{ $t('1288') }} </span>
        <a :href="useUrl" target="_blank" @click="onAgree">
          <span class="agree">{{ $t('1289') }}</span>
        </a>
      </div>
      <!-- 下一步 -->
      <gl-button :disabled="!isClick" class="login-btn" @click="handleLogin" :loading="loading" type="primary">{{
        $t('login.11')
      }}</gl-button>
    </el-form>
  </div>
</template>

<script>
// 获取图片验证码
import { getImgCode } from 'api/common'
// 登录api
import { registerApi, getRegisterShortCode } from 'api/login'
// token操作
import { utilCookies } from '@/util/cookies'
// button
import GlButton from '@/components/gl-button'
// 使用条款
export default {
  components: {
    GlButton
  },
  data() {
    const str = utilCookies.getLanguage() || 'en'
    return {
      lang: str,
      // 用户协议
      agreeUrl: '',
      // 使用条款
      useUrl: '',
      // 图片验证码
      codeImg: '',
      disabled: {
        sendCode: false
      },
      surplusTime: -1,
      // 表单数据
      checked: false,
      ruleForm: {
        calling_code: '66',
        verify_code: '',
        sms_captcha_type: '1', // 1 注册 2 登录 3 重置密码 4 更换手机号
        mobile: ''
      },
      // 校验规则
      rules: {
        mobile: [{ required: true, message: this.$t('login.35'), trigger: 'blur' }],
        verify_code: [{ required: true, message: this.$t('login.36'), trigger: 'blur' }],
        captcha: [{ required: true, message: this.$t('login.9'), trigger: 'blur' }]
      },
      // 按钮loading
      loading: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    isClick() {
      const { calling_code, verify_code, mobile, captcha } = this.ruleForm
      const status = calling_code && verify_code && mobile && captcha && this.checked
      return status
    },
    codeText() {
      if (this.surplusTime === -1) {
        return this.$t('login.4')
      }
      if (this.surplusTime === -2) {
        return this.$t('login.10')
      }
      return this.surplusTime > 0 ? `${this.surplusTime}S` : this.$t('login.4')
    }
  },
  methods: {
    init() {
      this.agreeUrl = `${process.env.VUE_APP_BASE_API}/auth/tool/terms?lang=${this.lang}`
      this.useUrl = `${process.env.VUE_APP_BASE_API}/auth/tool/tou?lang=${this.lang}`
      // 获取图片验证码
      this.handleImgCode()
      // 是否可以发送验证码
      // 全局mixin方法
      this.resetTimeCode(time => {
        if (time <= 0) {
          this.disabled.sendCode = false
        }
        this.surplusTime = time
      })
    },
    // 获取图片验证码
    handleImgCode() {
      // 图片验证码埋点
      // this.$ga.event('FHRSignup', 'click', 'ImageVerificationCode', 1)
      getImgCode().then(res => {
        if (res && res.code === 1) {
          this.codeImg = res.data
        }
      })
    },
    // 短信验证码
    handleShortCode() {
      this.ruleForm.sid = this.codeImg.sid
      // 校验是否输入图片验证码和手机号
      if (this.ruleForm.sid && this.ruleForm.mobile && this.ruleForm.captcha) {
        this.surplusTime = -1
        getRegisterShortCode(this.ruleForm)
          .then(res => {
            if (res && res.code === 1) {
              // 短信验证码埋点
              // this.$ga.event('FHRSignup', 'click', 'GetVerificationCode', 2)
              this.$message({
                message: this.$t('816'),
                type: 'success'
              })
              this.$s.set('codeTime', new Date().getTime())
              // 全局mixin方法
              this.resetTimeCode(time => {
                if (time <= 0) {
                  this.disabled.sendCode = false
                }
                this.surplusTime = time
              })
            }
          })
          .catch(() => {
            // 还原发送验证码
            this.surplusTime = -2
          })
      } else {
        this.$message({
          message: this.$t('817'),
          type: 'warning'
        })
      }
    },
    onAgree() {
      // 用户服务协议+使用条款埋点
      // this.$ga.event('FHRSignup', 'click', 'UserAgreement', 3)
    },
    // 账号登录
    handleLogin() {
      // 表单必填项验证
      this.$refs.form.validate(valid => {
        if (valid) {
          // this.$ga.event('FHRSignup', 'click', 'NextStep', 4)
          this.loading = true
          const msg = JSON.parse(JSON.stringify(this.ruleForm))
          registerApi(msg)
            .then(res => {
              if (res && res.code === 1) {
                this.$s.set('userInfo', res.data.user_info)
                utilCookies.setToken(res.data.access_token)
                this.$router.push({
                  path: '/register/team'
                })
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
